import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ children, dark = false }) {
  return (
    <div className="mb-5 flex items-center gap-3">
      <span className={`h-px w-10 ${dark ? "bg-maple" : "bg-aqua-600"}`} />
      <span
        className={`text-[11px] font-bold uppercase tracking-[0.25em] ${
          dark ? "text-maple" : "text-aqua-700"
        }`}
      >
        {children}
      </span>
    </div>
  );
}

export function TopWave({ fill }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 -top-[58px] md:-top-[78px]" aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="block h-[60px] w-full md:h-20">
        <path d="M0,52 C240,88 480,12 720,36 C960,60 1200,78 1440,32 L1440,80 L0,80 Z" fill={fill} />
      </svg>
    </div>
  );
}

export function BottomWave({ fill }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0" aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="block h-[60px] w-full rotate-180 md:h-20">
        <path d="M0,52 C240,88 480,12 720,36 C960,60 1200,78 1440,32 L1440,80 L0,80 Z" fill={fill} />
      </svg>
    </div>
  );
}
